import React from 'react';
import { TablePagination } from './../../../../../themes/table';
import API from './../../../../../config/api';

class Tpagination extends React.Component {

  render(){

    const { count, page, onChangePage } = this.props;
    const rowsPerPage = API.pagination.items;

    return(
      <TablePagination
        component="div"
        count={ count }
        rowsPerPage={ rowsPerPage }
        rowsPerPageOptions={[]}
        page={ parseInt(page,10) }
        backIconButtonProps={{
          'aria-label': 'Previous Page',
        }}
        nextIconButtonProps={{
          'aria-label': 'Next Page',
        }}
        onChangePage={ onChangePage }
      />
    )

  }

}

export default Tpagination;
